import { render, staticRenderFns } from "./dept-roles-page.vue?vue&type=template&id=7382ae4a&scoped=true"
import script from "./dept-roles-page.vue?vue&type=script&lang=js"
export * from "./dept-roles-page.vue?vue&type=script&lang=js"
import style0 from "./dept-roles-page.vue?vue&type=style&index=0&id=7382ae4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7382ae4a",
  null
  
)

export default component.exports